import React, { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import './LoginRequiredPopup.css';

const LoginRequiredPopup = ({ 
  isOpen, 
  onClose, 
  title = "Login Required",
  message = "You need to be logged in to access this feature.",
  subtitle = "Join GoBag to discover and create amazing collections!",
  returnUrl = null
}) => {
  const { openAuthModal } = useAuth();

  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  const handleRedirectToLogin = () => {
    onClose();
    openAuthModal('signin', true);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="login-popup-content" onClick={e => e.stopPropagation()}>
        <div className="login-popup-header">
          <h3>{title}</h3>
          <button 
            className="close-button"
            onClick={onClose}
            aria-label="Close popup"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div className="login-popup-body">
          <div className="login-popup-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
              <polyline points="10,17 15,12 10,7"></polyline>
              <line x1="15" y1="12" x2="3" y2="12"></line>
            </svg>
          </div>
          <p>{message}</p>
          <p className="login-popup-subtitle">{subtitle}</p>
        </div>
        <div className="login-popup-actions">
          <button 
            className="btn btn-secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className="btn btn-primary"
            onClick={handleRedirectToLogin}
          >
            Login / Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginRequiredPopup;
